export default "__VITE_ASSET__08e7ff2e__"